import { useState } from "react";

export const CheckboxListInput = ({
  label,
  options = [], // Array of strings: ["Action 1", "Action 2", "Action 3"]
  defaultValue = [], // Array of checked values: ["Action 1", "Action 3"]
  onValueChange,
}) => {
  const [checkedValues, setCheckedValues] = useState(() => {
    // Ensure defaultValue is an array
    if (Array.isArray(defaultValue)) {
      return defaultValue;
    }
    return [];
  });

  const handleToggle = (option) => {
    const newCheckedValues = checkedValues.includes(option)
      ? checkedValues.filter((val) => val !== option)
      : [...checkedValues, option];

    setCheckedValues(newCheckedValues);

    if (onValueChange) {
      onValueChange(newCheckedValues);
    }
  };

  const isChecked = (option) => checkedValues.includes(option);

  return (
    <div className="d-flex flex-column w-full">
      {label && (
        <label
          style={{
            color: "#C8CED3",
            fontSize: 16,
            fontWeight: 500,
            marginBottom: "24px",
          }}
        >
          {label}
        </label>
      )}

      <div className="d-flex flex-column" style={{ gap: "16px" }}>
        {options.map((option, index) => (
          <CheckboxItem
            key={index}
            label={option}
            checked={isChecked(option)}
            onToggle={() => handleToggle(option)}
          />
        ))}
      </div>
    </div>
  );
};

const CheckboxItem = ({ label, checked, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      type="button"
      style={{
        width: "100%",
        padding: "16px 20px",
        backgroundColor: checked ? "#0D6EFD" : "#1B2C3A",
        borderRadius: "24px",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        transition: "all 0.2s ease",
        minHeight: "56px",
      }}
    >
      <span
        style={{
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          lineHeight: "24px",
          textAlign: "left",
        }}
      >
        {label}
      </span>

      {checked && (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          style={{ flexShrink: 0, marginLeft: "12px" }}
        >
          <path
            d="M20 6L9 17L4 12"
            stroke="#00FF00"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
};
